// LanguageContext.jsx
'use client';

import React, { createContext, useContext, useState, useEffect } from 'react';

const LanguageContext = createContext();

// Helper function to get cookie value by name
const getCookie = (name) => {
    if (typeof document === 'undefined') return null;
    
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
    return null;
};

// Helper function to set cookie
const setCookie = (name, value, maxAge = 31536000) => {
    if (typeof document === 'undefined') return;
    
    document.cookie = `${name}=${value}; path=/; max-age=${maxAge}`;
};

export const LanguageProvider = ({ children }) => {
    const [locale, setLocale] = useState('es');

    useEffect(() => {
        // Leer el idioma desde la cookie
        const savedLocale = getCookie('NEXT_LOCALE');

        if (savedLocale) {
            setLocale(savedLocale);
        } else {
            // Si no existe, establecer el idioma por defecto
            setCookie('NEXT_LOCALE', 'es');
        }
    }, []);

    const changeLocale = (newLocale) => {
        setLocale(newLocale);
        setCookie('NEXT_LOCALE', newLocale);
    };

    return (
        <LanguageContext.Provider value={{ locale, changeLocale }}>
            {children}
        </LanguageContext.Provider>
    );
};

export const useLanguage = () => {
    return useContext(LanguageContext);
};
